// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d6e22361","505":"e88cf957","991":"9e26549f"}[chunkId] + ".chunk.js";
};